<template>
  <form id="form-add-parameter" class="position-relative" @submit.prevent="submit">
    <loader :loading="loadingForm" block />

    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        {{ formTitle }}
      </v-card-title>

      <v-card-text class="py-1">
        <AddDocument></AddDocument>
      </v-card-text>

      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-btn v-if="!isShowMode" id="form-add-parameter-cancel" type="button" color="primary" text @click="close">
          Отменить
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="!isShowMode" id="form-add-parameter-submit" type="submit" color="primary" text>Сохранить</v-btn>
        <v-btn v-if="isShowMode" id="form-add-parameter-close" type="button" color="primary" text @click="close">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper";
import Loader from "@/components/Loader";
import { formModal } from "@/mixins/modal/form-modal";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";

export default {
  name: "AddParameter",

  components: { AddDocument, Loader },

  mixins: [formModal],

  props: {
    date: {
      type: String,
      default: "",
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    customerForm: {
      //type: Object,
      default: null,
    },
  },

  data: () => ({
    formTitle: "Добавить параметр",
    loadingForm: false,
    loadingShowModeForm: false,

    loadingTypes: false,
    eventsTypes: [],
    formFields: [],

    form: {
      author: "",
      category: "",
    },

    dynamicForm: {
      name: "",
      real_date: "",
    },
  }),

  validations: {
    form: {
      category: { required },
    },
  },

  computed: {
    isShowMode() {
      return this.$props.readonly && this.customerForm !== null;
    },

    typeErrors() {
      return messageHelper(this.$v.form.category);
    },
  },

  async created() {
    this.dynamicForm.real_date = this.$props.date;

    if (this.isShowMode) {
      await this.readForm(this.$props.customerForm);
    } else {
      await this.loadData();
    }
  },

  methods: {
    async loadData() {
      // this.loading(true);
      // this.loading(false);
    },

    async submit() {
      this.$emit("close");
      this.$v.form.$touch();

      if (this.$v.form.$pending || this.$v.form.$error) return;

      // this.loading(true);
      // this.loading(false);
    },
  },
};
</script>

<style scoped></style>
